import { AsyncPipe } from '@angular/common';
import { Component, HostBinding } from '@angular/core';

import { NOT_APPLICABLE } from '@frontend/sports/tracking/feature';
import { BannerType, BannerViewModel } from '@frontend/sports/types/components/banners/models';
import { DeviceService } from '@frontend/vanilla/core';
import { isEmpty } from 'lodash-es';
import { Observable } from 'rxjs';

import { ArcRestrictionService } from '../arc/arc-restriction.service';
import { ComponentLoaderComponent } from '../deferred/component-loader.component';
import { WidgetComponent } from '../widget/core/widget-registry.service';
import { BannerEsportComponent } from './banner-esport.component';
import { BannerGamesComponent } from './banner-games.component';
import { BannerJackpotComponent } from './banner-jackpot.component';
import { BannerTrackingService } from './banner-tracking.service';
import { ofType } from './banner.model';
import { CasinoBannerLinkComponent } from './casino-banner-link.component';
import { SportBannerLinkComponent } from './sport-banner-link.component';
import { VymlComponent } from './vyml.component';
import { VymlService } from './vyml.service';

@Component({
    selector: 'ms-banner-widget',
    templateUrl: './banner-widget.component.html',
    imports: [
        AsyncPipe,
        BannerEsportComponent,
        BannerGamesComponent,
        BannerJackpotComponent,
        CasinoBannerLinkComponent,
        ComponentLoaderComponent,
        SportBannerLinkComponent,
        VymlComponent,
    ],
    providers: [BannerTrackingService, VymlService],
})
export class BannerWidgetComponent extends WidgetComponent<BannerViewModel> {
    @HostBinding('class') className = 'banner-widget';

    @HostBinding('class.esport')
    get esportClass() {
        return this.banner?.type === BannerType.Esport;
    }

    @HostBinding('style.--component-loader-height')
    get bannerComponentSize() {
        if (!this.showLoader) {
            return;
        }

        switch (this.banner?.type) {
            case BannerType.CasinoLink:
                return '70px';
            case BannerType.Games:
            case BannerType.Vyml:
                return '137px';
            case BannerType.Jackpot:
                return '100px';
            case BannerType.SportLink:
                return '76px';
            case BannerType.Esport:
                return '82px';
            default:
                return;
        }
    }

    @HostBinding('style.--component-loader-padding') bannerComponentPadding = '0';

    banner?: BannerViewModel;
    position = NOT_APPLICABLE;
    hideGamingCrossSellByArc$: Observable<boolean>;
    showLoader = true;

    constructor(
        private device: DeviceService,
        private arcRestrictionService: ArcRestrictionService,
    ) {
        super();
        this.hideGamingCrossSellByArc$ = this.arcRestrictionService.gamingCrossSellEnabled$;
    }

    protected override onData(data?: BannerViewModel): void {
        if (this.device.isRobot) {
            this.hasData = false;
        } else {
            this.hasData = !isEmpty(data);
            this.banner = data;
        }

        this.setWidgetLoaded();
    }

    bannerDataLoaded(hasBannerData: boolean): void {
        this.hasData = hasBannerData;
        this.showLoader = false;
        this.setWidgetLoaded();
    }

    protected readonly ofType = ofType;
}
